"use client";

import type { ResolvedHeaderAction } from "@/utils/header-actions";
import type { NavigationBreakpoint } from "@/hooks/useMinWidth";
import HeaderActionItem, { type HeaderActionIcons } from "./HeaderActionItem";

/** The first `mobile: "bottomBar"` action as a fixed bar on mobile; the page reserves room for it in CSS. */
export default function HeaderBottomBar({
  actions,
  bp,
  icons,
  onSearch,
}: {
  actions: ResolvedHeaderAction[];
  bp: NavigationBreakpoint;
  icons?: HeaderActionIcons;
  onSearch?: () => void;
}) {
  const action = actions.find((item) => item.mobile === "bottomBar");
  if (!action) return null;
  return (
    <div className="re-nav-bottombar" data-re-menu-companion data-bp={bp}>
      <HeaderActionItem
        action={action}
        placement="bottom"
        icons={icons}
        onSearch={onSearch}
      />
    </div>
  );
}
